import { useState } from "react";
import { ArrowLinkButton } from "~/components/ArrowLinkButton";
import { CITIES, type City } from "~/lib/cities";

type Props = {
  /** If provided, links to /{serviceSlug}/{city}/ — use on service pages */
  serviceSlug?: string;
  cities?: City[];
  title?: string;
  subtitle?: string;
  showAllByDefault?: boolean;
  maxVisible?: number;
};

const INITIAL_VISIBLE_CITIES = 10;

const CityGrid: React.FC<Props> = ({
  serviceSlug,
  cities,
  title = "Wybierz swoje miasto",
  subtitle = "Porównaj oferty certyfikowanych firm w Twojej okolicy",
  showAllByDefault = false,
  maxVisible = INITIAL_VISIBLE_CITIES,
}) => {
  const cityList = cities ?? CITIES;
  const [isExpanded, setIsExpanded] = useState(showAllByDefault);
  const visibleCities =
    isExpanded || showAllByDefault ? cityList : cityList.slice(0, maxVisible);
  const shouldShowToggle =
    !showAllByDefault && cityList.length > maxVisible;

  return (
    <section className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
      <div className="mb-8 text-center">
        <h2 className="text-2xl font-bold text-[#1B3A5C] sm:text-3xl">{title}</h2>
        <p className="mt-2 text-gray-500">{subtitle}</p>
      </div>

      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
        {visibleCities.map((city) => {
          const href = serviceSlug
            ? `/${serviceSlug}/${city.slug}/`
            : `/${city.slug}/`;

          return (
            <ArrowLinkButton
              key={city.slug}
              href={href}
              label={city.name}
              compact
            />
          );
        })}
      </div>

      {shouldShowToggle && (
        <div className="mt-5 flex justify-center">
          <button
            type="button"
            onClick={() => setIsExpanded((prev) => !prev)}
            className="rounded-lg border border-[#E5E7EB] bg-white px-4 py-2 text-sm font-semibold text-[#0C1F3F] transition-all duration-200 hover:border-[#00A87A] hover:bg-[#E8FAF4] hover:text-[#0C1F3F]"
          >
            {isExpanded ? "Zwiń" : "Rozwiń"}
          </button>
        </div>
      )}
    </section>
  );
};

export { CityGrid };
